import { useEffect, useState } from "react";
import { IoCalendarOutline } from "react-icons/io5";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { MdOutlineDocumentScanner, MdOutlineFileUpload, MdOutlineLibraryBooks } from "react-icons/md";
import { FaAngleRight, FaCar, FaRegUser } from "react-icons/fa";
import Verification from "./Verification"
import Handler from '../Helpers/Handler'
import { LuPhone } from "react-icons/lu";
import { HiOutlineMailOpen } from "react-icons/hi";
import { FiMail, FiPhone } from "react-icons/fi";
import { GrLocation } from "react-icons/gr";
import moment from "moment";

const Dashboard = () => {
    const { profileDetails } = useAuth();
    const [bookingDetails, setBookingDetails] = useState([]);
    const [next, setNext] = useState(false);
    const [count, setCount] = useState(5);
    const [profile, setProfile] = useState("kyc")
    const [selectedVerification, setSelectedVerification] = useState(null);
    const [request, setRequest] = useState({})
    const [stage, setStage] = useState("all")
    const [loading, setLoading] = useState(false)

    const REQUEST_KEYS = {
        profile: {
            subTitle: "IDENTITY",
            label: "Profile Photo",
            icon: <FaRegUser />
        },
        altNumber1: {
            subTitle: "VERIFICATION",
            label: "Alternate Number 1",
            icon: <FiPhone />
        },
        altNumber2: {
            subTitle: "VERIFICATION",
            label: "Alternate Number 2",
            icon: <FiPhone />
        },
        emailId: {
            subTitle: "VERIFICATION",
            label: "Email Id",
            icon: <FiMail />
        },
        dl: {
            subTitle: "KYC",
            label: "Driving License",
            icon: <MdOutlineDocumentScanner />
        },
        aadhaar: {
            subTitle: "KYC",
            label: "Aadhaar",
            icon: <MdOutlineDocumentScanner />
        },
        passport: {
            subTitle: "KYC",
            label: "Passport",
            icon: <MdOutlineDocumentScanner />,
        },
        profile2: {
            subTitle: "IDENTITY",
            label: "Co-Passenger's Photo",
            icon: <FaRegUser />
        },
        dl2: {
            subTitle: "KYC",
            label: "Co-Passenger's Driving License",
            icon: <MdOutlineDocumentScanner />
        },
        aadhaar2: {
            subTitle: "KYC",
            label: "Co-Passenger's Aadhaar",
            icon: <MdOutlineDocumentScanner />,
        },
        passport2: {
            subTitle: "KYC",
            label: "Co-Passenger's Passport",
            icon: <MdOutlineDocumentScanner />,
        }
    };

    const getBookings = async () => {
        setLoading(true)
        console.log(stage)
        const response = await Handler({ method: 'POST', url: `/customer/bookings/${count}`, data: { ...(stage !== "all" ? { stage } : {}) } })
        if (response?.success) {
            setBookingDetails(response?.data?.data || []);
            setNext(response?.data?.next || false);
        } else {
            setBookingDetails([]);
            setNext(false);
        }
        setLoading(false)
    };

    useEffect(() => {
        getBookings();
    }, [count, stage]);

    useEffect(() => {
        if (profileDetails) setRequest({
            profile: profileDetails?.requestsList?.find(req => req.requestKey === "profile"),
            altNumber1: profileDetails?.requestsList?.find(req => req.requestKey === "altNumber1"),
            altNumber2: profileDetails?.requestsList?.find(req => req.requestKey === "altNumber2"),
            emailId: profileDetails?.requestsList?.find(req => req.requestKey === "emailId"),
            dl: profileDetails?.requestsList?.find(req => req.requestKey === "dl"),
            aadhaar: profileDetails?.requestsList?.find(req => req.requestKey === "aadhaar"),
            passport: profileDetails?.requestsList?.find(req => req.requestKey === "passport"),
            profile2: profileDetails?.requestsList?.find(req => req.requestKey === "profile2"),
            dl2: profileDetails?.requestsList?.find(req => req.requestKey === "dl2"),
            aadhaar2: profileDetails?.requestsList?.find(req => req.requestKey === "aadhaar2"),
            passport2: profileDetails?.requestsList?.find(req => req.requestKey === "passport2"),
            primaryNumber: profileDetails?.requestsList?.find(req => req.requestKey === "primaryNumber"),
            voter: profileDetails?.requestsList?.find(req => req.requestKey === "voter"),
        })
    }, [profileDetails])

    return (
        <div className="container-fluid">
            <div className="row align-items-stretch">
                <div className="col-xl-3 col-lg-4">
                    <div className="profile-left-card">
                        <div className="profile-image-background">
                            <div className="profile-photo-image">
                                {profileDetails?.firstName?.slice(0, 1)}{profileDetails?.lastName?.slice(0, 1)}
                            </div>
                        </div>
                        <div className="profile-left-padding">
                            <div className="profile-view-name">{profileDetails?.firstName || ""} {profileDetails?.lastName || ""}</div>
                            <div className="profile-view-mobile">
                                <div className="profile-view-mobile-text">
                                    <div className="profile-phone-image">
                                        <LuPhone style={{ height: '22px', width: '22px' }} />
                                    </div>
                                    <div>
                                        <span className="phone-text">Phone Number</span>
                                        <div className="phone-number-text">{profileDetails?.customerDetail?.phone?.length && profileDetails?.customerDetail?.phone?.filter(ele => ele.priority === 1)?.length ? <> {profileDetails?.customerDetail?.phone?.find(ele => ele.priority === 1)?.code || ""} {profileDetails?.customerDetail?.phone?.find(ele => ele.priority === 1)?.phone || ""}</> : "-"}</div>
                                    </div>
                                </div>
                                <div className="profile-line"></div>
                                <div className="profile-view-mobile-text">
                                    <div className="profile-phone-image">
                                        <HiOutlineMailOpen style={{ height: '22px', width: '22px' }} />
                                    </div>
                                    <div>
                                        <span className="phone-text">Email</span>
                                        <div className="phone-number-text">{profileDetails?.customerDetail?.email?.emailId || "-"}</div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="profile-preference">Preferences</div>
                                <ul className="profile-ul">
                                    <li>
                                        <button onClick={() => setProfile("kyc")} className={`${profile === "kyc" ? "active-profile-btn" : ""}`}> <div className="d-flex align-items-center gap-1"> <span className="d-flex"> <MdOutlineDocumentScanner /> </span> <span>KYC</span></div> <div><FaAngleRight /></div> </button></li>
                                    <li>
                                        <button onClick={() => { setCount(5); setStage("all"); setProfile("booking") }} className={`${profile === "booking" ? "active-profile-btn" : ""}`}> <div className="d-flex align-items-center gap-1"> <span className="d-flex"> <MdOutlineLibraryBooks /> </span> <span>Booking</span></div> <div><FaAngleRight /></div> </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-9 col-lg-8">
                    <div className="profile-right-card">
                        <div className="profile-right-title">{profile === "kyc" ? "KYC" : profile === "booking" ? "Booking" : ""}</div>
                        {
                            profile === "kyc" ?
                                <div className="row align-items-stretch justify-content-start">
                                    {
                                        profileDetails?.requestsList?.filter(val => REQUEST_KEYS[val?.requestKey])?.map((val, i) => {
                                            const data = REQUEST_KEYS[val?.requestKey];
                                            return (
                                                <div className="col-xl-4 col-md-6 my-2" key={val?.requestKey || i}>
                                                    <div className="profile-right-small-cards">
                                                        <div className="profile-right-top-title">
                                                            <div className="d-flex flex-column">
                                                                <div className="profile-right-small-title">{data?.subTitle}</div>
                                                                <div className="profile-right-title-text">{data?.label}</div>
                                                            </div>
                                                            <div>
                                                                {request?.[val?.requestKey]?.keyStatus === "Uploaded" && (<span className="badge d-flex align-items-center text-bg-success rounded-pill">Uploaded</span>)}
                                                                {/* {request?.[val?.requestKey]?.rejected && (<span className="badge d-flex align-items-center text-bg-danger rounded-pill">Rejected</span>)} */}
                                                                {request?.[val?.requestKey]?.keyStatus === "Pending" && (<span className="badge d-flex align-items-center text-bg-warning rounded-pill">Pending</span>)}
                                                                {request?.[val?.requestKey]?.keyStatus === "Approved" && (<span className="badge d-flex align-items-center text-bg-success rounded-pill">Approved</span>)}
                                                            </div>
                                                        </div>
                                                        <div className="dotted-lines">{data?.icon}</div>
                                                        {request?.[val?.requestKey]?.rejected && request?.[val?.requestKey]?.keyStatus === "Pending" ? <div className="mt-2 reason-text">Rejected: {request?.[val?.requestKey]?.reason}</div> : ""}
                                                        {request?.[val?.requestKey]?.keyStatus === "Pending" && (<button className="profile-right-btn" data-bs-toggle="modal" data-bs-target="#verification" onClick={() => setSelectedVerification(val)}><MdOutlineFileUpload style={{ height: "18px", width: "18px" }} /><span>Upload</span></button>)}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div> :
                                <div>
                                    <ul className="profile-right-booking-tabs">
                                        <li><button className={`btn ${stage === "all" ? "active" : ""}`} onClick={() => { setStage("all"); setCount(5) }}>All</button></li>
                                        <li><button className={`btn ${stage === "Booked" ? "active" : ""}`} onClick={() => { setStage("Booked"); setCount(5) }}>Booked</button></li>
                                        <li><button className={`btn ${stage === "Ongoing" ? "active" : ""}`} onClick={() => { setStage("Ongoing"); setCount(5) }}>Ongoing</button></li>
                                        <li><button className={`btn ${stage === "Pending" ? "active" : ""}`} onClick={() => { setStage("Pending"); setCount(5) }}>Pending</button></li>
                                        <li><button className={`btn ${stage === "Completed" ? "active" : ""}`} onClick={() => { setStage("Completed"); setCount(5) }}>Completed</button></li>
                                        <li><button className={`btn ${stage === "Cancelled" ? "active" : ""}`} onClick={() => { setStage("Cancelled"); setCount(5) }}>Cancelled</button></li>
                                    </ul>
                                    <div className="profile-booking-list">
                                        {
                                            bookingDetails?.length ?
                                                bookingDetails?.map((ele, index) => {
                                                    return (
                                                        <div className="profile-booking-card" key={index}>
                                                            <div className="profile-booking-card-top">
                                                                <div className="car-name"> {ele.carData?.model} </div>
                                                                <div className={`status-btn ${ele.status}-btn`}> <span className={`status-tag ${ele.status}-tag`}></span> <span> {ele.status}</span></div>
                                                            </div>
                                                            <div className="profile-booking-bottom row">
                                                                <div className="col-md-4">
                                                                    <div className="profile-bottom-title"> <GrLocation style={{ height: '13px', width: '13px' }} /> <span> Delivery Location </span></div>
                                                                    <div className="profile-bottom-value">{ele.deliveryDetails?.location || "PO"}</div>
                                                                </div>
                                                                <div className="col-md-4 my-md-0 my-3">
                                                                    <div className="profile-bottom-title"> <GrLocation style={{ height: '13px', width: '13px' }} /> <span> Pickup Location </span></div>
                                                                    <div className="profile-bottom-value">{ele.pickupDetails?.location || "PO"}</div>
                                                                </div>
                                                                <div className="col-md-4 my-md-0 my-3">
                                                                    <div className="profile-bottom-title"> <IoCalendarOutline style={{ height: '13px', width: '13px' }} /> <span> Trip Dates </span></div>
                                                                    <div className="profile-bottom-value">{ele.deliveryDetails?.delivery ? moment(new Date(ele.deliveryDetails?.delivery)).format("DD MMM YYYY") : ""} - {ele.pickupDetails?.pickup ? moment(new Date(ele.pickupDetails?.pickup)).format("DD MMM YYYY") : ""}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className="booking-not-found">
                                                    <div className="no-booking-image"> <FaCar /> </div>
                                                    <div className="no-booking-text">No Bookings</div>
                                                    <div className="no-bookings-text">Your trips will show up here once you book a car.</div>
                                                </div>
                                        }
                                    </div>
                                    {next && !loading ?
                                        <div className="text-end mt-3">
                                            <button className="btn show-more-button" onClick={() => setCount(count + 5)}> Show More...</button>
                                        </div>
                                        : ""}
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className="modal fade" id="verification" tabIndex="-1" aria-labelledby="verificationLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content rounded-4 ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="verificationLabel" >
                                {REQUEST_KEYS[selectedVerification?.requestKey]?.label}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <Verification selected={selectedVerification} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;